'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '../utils/cn';

const colors = {
  primary: {
    range: 'bg-primary',
    thumb: 'border-primary',
  },
  accent: {
    range: 'bg-accent',
    thumb: 'border-accent',
  },
};

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    color?: 'primary' | 'accent';
  }
>(({ className, color, ...props }, ref) => {
  const colorClasses = color ? colors[color] : colors.primary;
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        'relative flex w-full touch-none select-none items-center',
        'data-[orientation=vertical]:flex-col data-[orientation=vertical]:flex-col data-[orientation=vertical]:w-2 data-[orientation=vertical]:h-full',
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={cn(
          'relative h-2 w-full grow overflow-hidden rounded-full bg-foreground/20',
          'data-[orientation=vertical]:w-2 data-[orientation=vertical]:h-full',
        )}
      >
        <SliderPrimitive.Range
          className={cn(
            'absolute h-full rounded-full',
            'data-[orientation=vertical]:w-full',
            colorClasses.range,
          )}
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          'block h-5 w-5 rounded-full border-2 bg-foreground ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
          colorClasses.thumb,
          props.disabled && 'opacity-0',
        )}
      />
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
